<template>
  <teleport to="#modalTeleport">
    <TemplateCropModal
      v-if="voucher.imgData || voucher.png"
      :image="voucher.imgData"
      :initialBounds="ticketTemplate.voucher_bounds"
      :png="voucher.png"
      @cancel="voucher.png = ''"
      @crop="cropVoucherTemplate"
      :aspectRatio="180 / 242"
      title="QR und Datenbereich definieren"
    ></TemplateCropModal>
    <TemplateCropModal
      v-if="badge.imgData || badge.png"
      :image="badge.imgData"
      :initialBounds="ticketTemplate.badge_bounds"
      :png="badge.png"
      @cancel="badge.png = ''"
      @crop="cropBadgeTemplate"
      :aspectRatio="57 / 16"
      title="Beschriftungsbereich definieren"
    ></TemplateCropModal>
  </teleport>
  <HeadlineComponent>Ticket Template "{{ name }}" bearbeiten</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="update"
    :initialValues="form"
    v-if="loaded"
  >
    <div class="form-group">
      <label for="name">Name</label>
      <BootstrapField type="text" name="name" placeholder="Name" />
    </div>
    <div class="form-group">
      <label for="subject">E-Mail Betreff</label>
      <BootstrapField type="text" name="subject" placeholder="Dein Ticket" />
    </div>
    <div class="form-group">
      <label>E-Mail Text</label>
      <QuillField
        name="text"
        placeholder="Hier ist dein Ticket..."
        v-if="loaded"
      />
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Aktuelles PDF Template</label>
          <img
            :src="`/api/event/${$route.params.event}/tickettemplate/${ticketTemplate.id}/png`"
            class="template-image"
            @click="recrop('voucher')"
            alt="Vorschaubild Voucher"
          />
          <small class="form-text"
            >Zum neu Positionieren auf das Bild klicken</small
          >
        </div>
        <div class="form-group">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="replaceTemplate"
              v-model="replaceTemplate"
            />
            <label class="form-check-label" for="replaceTemplate">
              Das Template ersetzen
            </label>
          </div>
        </div>
        <div class="form-group" v-if="replaceTemplate">
          <label for="pdf">PDF Template</label>
          <input
            type="file"
            class="form-control"
            id="pdf"
            accept="application/pdf"
            @change="handleFileUpload('voucher', $event)"
            :class="{ 'is-invalid': voucherToBig }"
          />
 <small class="form-text" :class="{ 'invalid-feedback': voucherToBig }"
            ><strong>Format: PDF 1.4</strong><br />Maximale Größe: 2Mb. Bedenke: Jedem Ticketinhaber wird diese PDF
            per Mail zugeschickt und im schlimmsten Fall müssen sie die PDF vor
            Ort mit schlechtem Internet herunterladen. Je kleiner desto
            besser.</small
          >
        </div>
      </div>
      <div class="col">
        <div class="form-group" v-if="ticketTemplate.has_badge">
          <label>Aktuelles Badge Template</label>
          <img
            :src="`/api/event/${$route.params.event}/tickettemplate/${ticketTemplate.id}/png?type=badge`"
            class="template-image"
            @click="recrop('badge')"
            alt="Vorschaubild Badge"
          />
          <small class="form-text"
            >Zum neu Positionieren auf das Bild klicken</small
          >
        </div>
        <div class="form-group" v-if="ticketTemplate.has_badge">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="replaceBadgeTemplate"
              v-model="replaceBadgeTemplate"
            />
            <label class="form-check-label" for="replaceBadgeTemplate">
              Das Badge Template ersetzen
            </label>
          </div>
        </div>
        <div
          class="form-group"
          v-if="replaceBadgeTemplate || !ticketTemplate.has_badge"
        >
          <label for="badge">Badge Template</label>
          <input
            type="file"
            class="form-control"
            id="badge"
            accept="application/pdf"
            @change="handleFileUpload('badge', $event)"
          />
           <small class="form-text" :class="{ 'invalid-feedback': voucherToBig }"
            ><strong>Format: PDF 1.4</strong></small
          >
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          class="form-check-input"
          id="crewticket"
          name="crewtemplate"
          :value="true"
        />
        <label class="form-check-label" for="crewticket">
          Dieses Template ist für normale Crew Tickets
        </label>
      </div>
      <div class="form-text">
        Wenn der Haken gesetzt ist, wird dieses Template dafür benutzt Tickets
        für normale Crew zu generieren.
      </div>
    </div>
    <LoadingButton class="btn-primary" :loading="loading"
      >Speichern</LoadingButton
    >
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import TemplateCropModal from "@/components/TemplateCropModal.vue";
import ticketService from "@/services/ticket.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import eventService from "@/services/event.service.js";
import QuillField from "../../components/QuillField.vue";
import { Field, Form } from "vee-validate";
import BootstrapField from "../../components/BootstrapField.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateTicketTemplateView",
  components: {
    LoadingButton,
    HeadlineComponent,
    TemplateCropModal,
    QuillField,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    BootstrapField,
    Field,
  },
  data() {
    return {
      voucherToBig: false,
      voucher: {
        file: "",
        png: "",
        imgData: "",
        imgFormData: "",
      },
      badge: {
        file: "",
        png: "",
        imgData: "",
        imgFormData: "",
      },
      name: "",
      replaceTemplate: false,
      replaceBadgeTemplate: false,
      ticketTemplate: {},
      form: {
        text: "",
      },
      loading: false,
      loaded: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    let ticketTemplate = {};
    try {
      let response = await ticketService.getTicketTemplate(
        to.params.event,
        to.params.id
      );
      ticketTemplate = response.data;
      response = await eventService.get(to.params.event);
      ticketTemplate.crewtemplate =
        response.data.crew_template === ticketTemplate.id;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.ticketTemplate = ticketTemplate;
      vm.form = {
        name: ticketTemplate.name,
        subject: ticketTemplate.subject,
        text: ticketTemplate.text,
        crewtemplate: ticketTemplate.crewtemplate,
      };
      vm.name = ticketTemplate.name;
      vm.loaded = true;
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async update(values) {
      this.loading = true;
      try {
        values.badge_bounds = this.ticketTemplate.badge_bounds;
        values.voucher_bounds = this.ticketTemplate.voucher_bounds;
        await ticketService.updateTicketTemplate(
          this.$route.params.event,
          this.ticketTemplate.id,
          values,
          this.voucher,
          this.badge
        );
        this.addAlert("success", "Ticket template erfolgreich bearbeitet");
        this.$router.push(
          `/events/${this.$route.params.event}/ticketTemplates`
        );
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
    handleFileUpload(type, event) {
      if (type === "voucher") {
        if (event.target.files[0].size > 2 * 1024 * 1024) {
          this.addAlert(
            "danger",
            "Die Voucher PDF darf maximal 2Mb groß sein."
          );
          window.scrollTo(0, 0);
          this.voucherToBig = true;
          return;
        } else {
          this.voucherToBig = false;
        }
      }

      this[type].file = event.target.files[0];
      let reader = new FileReader();
      reader.onload = (event) => {
        this[type].imgData = event.target.result;
      };
      reader.readAsArrayBuffer(this[type].file);
    },
    cropVoucherTemplate(res) {
      let bounds = res.bounds;
      this.ticketTemplate.voucher_bounds.x = bounds.x;
      this.ticketTemplate.voucher_bounds.y = bounds.y;
      this.ticketTemplate.voucher_bounds.w = bounds.w;
      this.ticketTemplate.voucher_bounds.h = bounds.h;
      if (!this.voucher.png) {
        this.voucher.imgData = "";
        this.voucher.imgFormData = res.image;
      } else {
        this.voucher.png = "";
      }
    },
    cropBadgeTemplate(res) {
      let bounds = res.bounds;
      this.ticketTemplate.badge_bounds.x = bounds.x;
      this.ticketTemplate.badge_bounds.y = bounds.y;
      this.ticketTemplate.badge_bounds.w = bounds.w;
      this.ticketTemplate.badge_bounds.h = bounds.h;
      if (!this.badge.png) {
        this.badge.imgData = "";
        this.badge.imgFormData = res.image;
      } else {
        this.badge.png = "";
      }
    },
    recrop(type) {
      var link = "png";
      if (type === "badge") {
        link = "png?type=badge";
      }
      this[type].png =
        `/api/event/${this.$route.params.event}/tickettemplate/${this.ticketTemplate.id}/${link}`;
    },
  },
};
</script>

<style scoped>
.template-image {
  display: block;
  max-height: 500px;
  width: auto;
}
</style>
